import React from 'react';
import './Footer.css';

function Footer() {
  return (
    <footer className='footer'>
      <div className='footer-content'>
        <p className='footer-text' dir='rtl'>
          כל הזכויות שמורות <span dir='ltr'>&copy; N.P.R Execution LTD 2026</span>
        </p>{' '}
        <p className='footer-text'>Developed by NPR</p>
        <p className='footer-text'>
          <a href="https://n-pr.co.il/privacy.html" target="_blank" rel="noopener">מדיניות פרטיות</a>
        </p>
      </div>
    </footer>
  );
}

export default Footer;
